import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation PayWithBankTransferMutation($input: PayWithBankTransferInput!) {
    payWithBankTransfer(input: $input) {
      order {
        id
        orderid
        state
        payment {
          state
        }
      }
    }
  }
`;

function commit(environment, orderId, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        orderId,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.payWithBankTransfer.order);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
